import { PropType } from 'vue';
import plantsClient from '@/core/services/plants';
import { Options, Vue } from 'vue-class-component';
import {
  BuildingDTO,
  EntrancePlantDetailDTO,
  PeRiserConfig,
} from '@/../client-generator/generated-clients/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { mapState } from 'vuex';
import NumberButtons from '@/views/components/NumberButtons/NumberButtons.vue';
import HelpPopupButton from '@/views/components/HelpPopupButton/HelpPopupButton.vue';
import { HelpType } from '@/views/components/HelpPopupButton/HelpPopupButton';

@Options({
  name: 'DialogAddRiser',
  components: {
    NumberButtons,
    HelpPopupButton,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    building: {
      type: Object as PropType<BuildingDTO>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
      if (this.isDialogVisible) {
        this.initRiser();
      }
    },
  },
  emits: ['hide-dialog', 'update-list', 'risers-created'],
})
export default class DialogAddRiser extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  building!: BuildingDTO;
  HelpType = HelpType;

  riserNumber: number = 1;

  isVisible!: boolean;
  isDialogVisible = false;

  get maxrisersNumber() {
    const maxPerPlant = 30;
    const currentRisersInPlant = this.currentEntrancePlant.buildings
      ?.flatMap((b) => b.risers || [])
      .length ?? 0;
    return maxPerPlant - currentRisersInPlant;
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  initRiser() {
    this.riserNumber = 1;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  get dialogTitle() {
    return this.$t('AppResourceEP.AddRisers');
  }

  get buttonSubmitLabel() {
    return this.$t('AppResource.Save');
  }

  get saveButtonDisabled() {
    return this.riserNumber < 1 || this.riserNumber > this.maxrisersNumber;
  }

  async handleButtonSubmitAction() {
    this.isDialogVisible = false;
    const newRiserIds = await this.saveRiser();
    this.$emit('update-list');
    if (newRiserIds.length > 0) {
      this.$emit('risers-created', newRiserIds);
    }
  }

  async saveRiser(): Promise<string[]> {
    if (this.currentEntrancePlant.desktopId === undefined) return [];
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      // Call create API with this.riserNumber
      const risersToAdd: PeRiserConfig[] = [];
      for (let i = 0; i < this.riserNumber; i++) {
        risersToAdd.push(new PeRiserConfig(
            {
              peBuildingConfigId: this.building.buildingId,
            }
          )
        );
      }
      const createdRisers = await plantsClient.riserAll(this.currentEntrancePlant.desktopId, risersToAdd);
      this.$toast.add({
        severity: 'success',
        summary: this.$t('AppResourceEP.RisersCreated'),
        closable: false,
        life: 3000,
      });
      return createdRisers.map(r => r.id).filter((id): id is string => id != null);
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('AppResource.Error'),
          closable: false,
          life: 3000,
        });
      }, 1500);
      return [];
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
